import { AutenticacaoCoreService } from "../domain/primecap/core/autenticacao-core.service";
import { UsuarioAutenticadoGuard } from "./usuario-autenticado.guard";
import { UsuarioNaoAutenticadoGuard } from "./usuario-nao-autenticado.guard";

export const guardsProviders = [
    AutenticacaoCoreService,
    UsuarioAutenticadoGuard,
    UsuarioNaoAutenticadoGuard
]